export enum ContactNoteStatus {
    Inactive = 'Inactive',
    Active = 'Active',
    Pinned = 'Pinned',
    ReadOnly = 'ReadOnly',
}
